const ONES = [
  '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
  'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
  'Seventeen', 'Eighteen', 'Nineteen',
]
const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety']

function twoDigits(n) {
  if (n < 20) return ONES[n]
  const ten = Math.floor(n / 10)
  const one = n % 10
  return TENS[ten] + (one ? ' ' + ONES[one] : '')
}

function threeDigits(n) {
  const hundred = Math.floor(n / 100)
  const rest = n % 100
  const parts = []
  if (hundred) parts.push(ONES[hundred] + ' Hundred')
  if (rest) parts.push((hundred ? 'and ' : '') + twoDigits(rest))
  return parts.join(' ')
}

// Converts a rupee amount into Indian-style words, e.g. 57173 ->
// "Fifty Seven Thousand One Hundred and Seventy Three Only".
export function numberToIndianWords(amount) {
  let num = Math.round(Number(amount) || 0)
  if (num === 0) return 'Zero Only'

  const crore = Math.floor(num / 10000000); num %= 10000000
  const lakh = Math.floor(num / 100000); num %= 100000
  const thousand = Math.floor(num / 1000); num %= 1000
  const rest = num

  const parts = []
  if (crore) parts.push(twoDigits(crore) + ' Crore')
  if (lakh) parts.push(twoDigits(lakh) + ' Lakh')
  if (thousand) parts.push(twoDigits(thousand) + ' Thousand')
  if (rest) parts.push(threeDigits(rest))

  return parts.join(' ') + ' Only'
}
